export default {
  title: 'Coming Soon'
};



// WEBPACK FOOTER //
// ./src/views/guest/coming-soon/ComingSoon.messages.js